export const KSC_API_URI =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
export const IOS_APP_DOWNLOAD_URL =
  "https://itunes.apple.com/se/app/keyflow-your-key-to-global/id963685753";
export const ANDROID_APP_DOWNLOAD_URL =
  "https://play.google.com/store/apps/details?id=se.keyflow.android.guest";
export const FALLBACK_KEYFLOW_WEBSITE_URL = "https://keyflow.com/";
export const FALLBACK_APP_DOWNLOAD_URL = "https://keyflow.com/app";
